<template>
    <div>
        <div class="title">待处理{{name}}提醒任务</div>
        <div class="timearea flex-n fjb fac">
            <el-button size="mini" @click="add">新增{{name}}</el-button>
            <div class="oneline" v-if="weekList[0]">{{weekList[0].yy}}年{{weekList[0].mm}}月{{weekList[0].dd}}日  ~  {{weekList[6].yy}}年{{weekList[6].mm}}月{{weekList[6].dd}}日</div>
            <el-button size="mini" @click="backtoday">回今天</el-button>
        </div>
        <div class="timelist  flex-n fjb fac">
            <i class="icon el-icon-caret-left"  v-pointer @click="beforeweek"></i>
            <div class="square flex-n fja fac" v-pointer :class="chooseday==index?'chooseborder':''" v-if="weekList" v-for="item,index in weekList" @click="getDate(index)">
                <div :class="today.date==item.date?'choose':''">
                    <template  v-for="(itm,idx) in importantList" v-if="index==idx&&itm.importantDates&&itm.importantDates.length!=0">
                        <el-popover
                                placement="top-start"
                                title="重点日期"
                                width="200"
                                trigger="hover"
                                :content="itm.content">
                            <div class="star"  slot="reference">
                            <i  class="el-icon-star-on"></i>
                            </div>
                        </el-popover>
                    </template>
                <div class="text">周
                    <span v-if="index==0">一</span>
                    <span v-if="index==1">二</span>
                    <span v-if="index==2">三</span>
                    <span v-if="index==3">四</span>
                    <span v-if="index==4">五</span>
                    <span v-if="index==5">六</span>
                    <span v-if="index==6">日</span>
                </div>
                <div class="text">{{item.dd}}</div>
                </div>
                <template  v-for="(itm,idx) in importantList" v-if="index==idx">

                <div class="dot" v-if="itm.record" :style="{background:today.date==item.date?'#00BFBF':'#000'}"></div>
                </template>
            </div>
            <i class="icon el-icon-caret-right" v-pointer @click="nextweek"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "z-calendar1",
        props:{
            name:String,
            impList:Array,//重点列表
        },
        data(){
            return{
                weekList:[],
                today:{},
                chooseday:0,
                importantList:[]
            }
        },
        mounted(){
            var d=new Date();
            this.today=this.$TM.getDayArea();
            this.backtoday();
        },
        watch:{
            weekList(newval,oldval){
                this.$emit('getDateRange',newval)
            },
            impList(newval,oldval){
                this.importantList=newval;
                for(var i in this.importantList){
                    var content='';
                    for(var j in this.importantList[i].importantDates) {
                        content += this.importantList[i].importantDates[j].importantDateLevel + ':' + this.importantList[i].importantDates[j].importantMsg + '、';
                    }
                    if(content.length>0){
                        content=content.substring(0,content.length-1);
                    }
                    this.importantList[i].content=content;
                }
            }
        },
        methods:{
            beforeweek(){
                this.chooseday=6;
                this.weekList=[].concat(this.$TM.beforeWeek(this.weekList[0]));
                this.$emit('getDate',this.weekList[6]);
            },
            backtoday(){
                this.weekList=this.$TM.getWeekArea();
                var d=new Date(this.today.yy,this.today.mm-1,this.today.dd);
                var a=d.getDay();
                if(a==0){
                    a=7;
                }
                this.chooseday=a-1;
                this.$emit('getDate',this.weekList[a-1])
            },
            nextweek(){
                this.chooseday=0;
                this.weekList=[].concat(this.$TM.afterWeek(this.weekList[6]))
                this.$emit('getDate',this.weekList[0])
            },
            add(){
               this.$emit('add')
            },
            getDate(index){
                this.chooseday=index;
                this.$emit('getDate',this.weekList[index])
                this.$emit('getDateRange',this.weekList)
            }
        }
    }
</script>

<style scoped lang="scss">
.title{
    height: 39px;
    line-height: 39px;
    background: #393d49;
    text-align: center;
    font-weight: 700;
    font-style: normal;
    font-size: 15px;
    color: #F2F2F2;
    letter-spacing: 8px;
}
    .timearea{
        height: 36px;
        background: white;
        padding: 0 20px;
        div{
            font-size: 13px;
        }
    }
    .timelist{
        margin-top: 10px;
        margin-bottom: 20px;
        .chooseborder{
           background: #e0e0e0 !important;
        }
        .choose{
            color: #00BFBF;
        }
        .icon{
           font-size: 22px;
            transform: scale(2);
        }
        .square{
            width: 5.5vw;
            min-width: 74px;
            height: 5.5vw;
            min-height: 68px;
            background-color: white;
            text-align: center;
            border-radius: 10px;
            position: relative;
            .star{
                position: absolute;
                top: 3px;
                right: 3px;
                color:#d81e06;
            }
            .text{
                width: 74px;
                font-weight: 700;
                font-size: 16px!important;
                span{
                    font-size: 16px!important;
                }
            }
            .dot{
               position: absolute;
                width: 10px;
                height: 10px;
                border-radius: 5px;
                background: #00BFBF;
                bottom: 3px;
            }
        }
    }
</style>